// extracted by mini-css-extract-plugin
export default {"sectionTitle":"MenuSection_sectionTitle__A-tVF","sectionContainer":"MenuSection_sectionContainer__C9PLZ"};